import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { IonicModule } from '@ionic/angular';
import { BarcodeScannerService } from './barcode-scanner.service';
import { CartButtonComponent } from './cart-button/cart-button.component';
import { UtilService } from './util.service';

@NgModule({
  declarations: [CartButtonComponent],
  exports: [CartButtonComponent],
  providers: [UtilService, BarcodeScannerService],
  imports: [
    CommonModule,
    IonicModule,
    RouterModule,
  ]
})
export class CoreModule { }
